export default __webpack_public_path__ + "static/media/Notes-cuate.5fd102bf.png";